import React, { useState } from "react";
import axios from "axios";
// import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useNavigate, Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { base_api_url } from "../../../environment.jsx";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import SessionControl from "../../components/SessionControl/sessioncheck";
import "./register.css";

const MySwal = withReactContent(Swal);

const Register = () => {
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const [formData, setFormData] = useState({
    "nom": "",
    "prenom": "",
    "email": "",
    "telephone": "",
    "mot_de_passe": "",
    "repassword": ""
  });

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [termsAccepted, setTermsAccepted] = useState(false);
  const route = all_routes;
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    if (formData.mot_de_passe !== formData.repassword) {
      MySwal.fire({
        icon: "error",
        text: "Les mots de passe ne correspondent pas.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      setLoading(false);
      return;
    }
    try {
      const response = await axios.post(`${base_api_url}api/users`, formData);

      MySwal.fire({
        icon: "success",
        text: "Votre compte a été créé avec succès !",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      localStorage.setItem("user", JSON.stringify(response.data));
      setTimeout(() => {
        navigate(route.Restaurants);
      }, 1000);

    } catch (error) {
      let errorMessage = "Erreur lors de l'inscription.";

      const errorData = error.response?.data;
      const status = error.response?.status;
      const allErrorsString = JSON.stringify(errorData || "").toLowerCase();

      if (
        status === 409 ||
        status === 422 ||
        allErrorsString.includes("email") ||
        allErrorsString.includes("existe") ||
        allErrorsString.includes("déjà") ||
        allErrorsString.includes("taken") ||
        allErrorsString.includes("used")
      ) {
        errorMessage = "Cette adresse e-mail est déjà utilisée. Veuillez utiliser une autre adresse ou vous connecter.";
      }

      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      console.error("Erreur :", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="qrnyama-register-container">
      <SessionControl
        storageKey="user"
        redirectTo={route.menus}
      />
      <div className="qrnyama-register-wrapper">
        {/* Left Panel - Branding (Hidden on Mobile) */}
        <div className="qrnyama-left-panel">
          <div className="qrnyama-blur-circle-top"></div>
          <div className="qrnyama-blur-circle-bottom"></div>

          <div className="qrnyama-left-content">
            <div className="qrnyama-logo-container" onClick={() => navigate('/')}>
              <div className="qrnyama-logo-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="5" height="5" x="3" y="3" rx="1" />
                  <rect width="5" height="5" x="16" y="3" rx="1" />
                  <rect width="5" height="5" x="3" y="16" rx="1" />
                  <rect width="5" height="5" x="16" y="16" rx="1" />
                </svg>
              </div>
              <span className="qrnyama-logo-text">
                QR<span>NYAMA</span>
              </span>
            </div>

            <div className="qrnyama-branding-content">
              <h2 className="qrnyama-branding-title">
                Rejoignez le nouveau <br />
                <span>standard digital.</span>
              </h2>
              <p className="qrnyama-branding-subtitle">
                Plus de 500 restaurateurs ont augmenté leur rentabilité de 25% dès le premier mois.
              </p>
            </div>
          </div>

          <div>
            <div className="qrnyama-guarantee-box">
              <div className="qrnyama-guarantee-header">
                <div className="qrnyama-guarantee-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                </div>
                <p className="qrnyama-guarantee-title">Garantie Zéro Friction</p>
              </div>
              <p className="qrnyama-guarantee-text">
                Installation en 48h, formation incluse et assistance 7j/7. Concentrez-vous sur votre cuisine, nous gérons le reste.
              </p>
            </div>
            <p className="qrnyama-copyright">© 2026 QRNYAMA. Tous droits réservés.</p>
          </div>
        </div>

        {/* Right Panel - Form */}
        <div className="qrnyama-right-panel">
          {/* Mobile Logo */}
          <div className="qrnyama-mobile-logo" onClick={() => navigate('/')}>
            <div className="qrnyama-mobile-logo-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect width="5" height="5" x="3" y="3" rx="1" />
                <rect width="5" height="5" x="16" y="3" rx="1" />
                <rect width="5" height="5" x="3" y="16" rx="1" />
                <rect width="5" height="5" x="16" y="16" rx="1" />
              </svg>
            </div>
            <span className="qrnyama-mobile-logo-text">
              QR<span>NYAMA</span>
            </span>
          </div>

          <div className="qrnyama-form-container">
            <div className="qrnyama-form-header">
              <h3 className="qrnyama-form-title">Créez votre compte</h3>
              <p className="qrnyama-form-subtitle">
                Commencez votre essai gratuit de 14 jours dès maintenant.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="qrnyama-register-form">
              {/* Name Fields Row */}
              <div className="qrnyama-form-row">
                <div className="qrnyama-form-group">
                  <label className="qrnyama-form-label">
                    Nom <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="qrnyama-form-input"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    placeholder="Dupont"
                    required
                  />
                </div>
                <div className="qrnyama-form-group">
                  <label className="qrnyama-form-label">
                    Prénom <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="qrnyama-form-input"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    placeholder="Jean"
                    required
                  />
                </div>
              </div>

              {/* Email Field */}
              <div className="qrnyama-form-group">
                <label className="qrnyama-form-label">
                  Adresse Email Professionnelle <span>*</span>
                </label>
                <input
                  type="email"
                  className="qrnyama-form-input"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="contact@restaurant.com"
                  required
                />
              </div>

              {/* Phone Field */}
              <div className="qrnyama-form-group">
                <label className="qrnyama-form-label">
                  Téléphone <span>*</span>
                </label>
                <input
                  type="tel"
                  className="qrnyama-form-input"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  placeholder="+33 6 12 34 56 78"
                  required
                />
              </div>

              {/* Password Field */}
              <div className="qrnyama-form-group">
                <label className="qrnyama-form-label">
                  Mot de passe <span>*</span>
                </label>
                <div className="qrnyama-password-wrapper">
                  <input
                    type={passwordVisibility.password ? "text" : "password"}
                    className="qrnyama-form-input"
                    name="mot_de_passe"
                    value={formData.mot_de_passe}
                    onChange={handleChange}
                    placeholder="Minimum 8 caractères"
                    required
                  />
                  <button
                    type="button"
                    className="qrnyama-password-toggle"
                    onClick={() => togglePasswordVisibility("password")}
                  >
                    {passwordVisibility.password ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                        <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                        <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                        <line x1="2" x2="22" y1="2" y2="22" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Confirm Password Field */}
              <div className="qrnyama-form-group">
                <label className="qrnyama-form-label">
                  Confirmer le mot de passe <span>*</span>
                </label>
                <div className="qrnyama-password-wrapper">
                  <input
                    type={passwordVisibility.confirmPassword ? "text" : "password"}
                    className="qrnyama-form-input"
                    name="repassword"
                    value={formData.repassword}
                    onChange={handleChange}
                    placeholder="Confirmez votre mot de passe"
                    required
                  />
                  <button
                    type="button"
                    className="qrnyama-password-toggle"
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  >
                    {passwordVisibility.confirmPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                        <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                        <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                        <line x1="2" x2="22" y1="2" y2="22" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Terms Checkbox */}
              <div className="qrnyama-checkbox-wrapper">
                <input
                  type="checkbox"
                  id="terms"
                  className="qrnyama-checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  required
                />
                <label htmlFor="terms" className="qrnyama-checkbox-label">
                  J&apos;accepte les{" "}
                  <a href="https://qrnyama.com/cguv.html" target="_blank" rel="noopener noreferrer">Conditions Générales de Vente</a> et la{" "}
                  <a href="https://qrnyama.com/cguv.html" target="_blank" rel="noopener noreferrer">Politique de Confidentialité</a>.
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={!termsAccepted || loading}
                className="qrnyama-submit-btn"
              >
                {loading ? "Création en cours..." : "Créer mon compte"}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" x2="19" y1="12" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </form>

            {/* Divider */}
            {/* <div className="qrnyama-divider">
              <span>Ou s&apos;inscrire avec</span>
            </div> */}

            {/* Social Login Buttons */}
            {/* <div className="qrnyama-social-buttons">
              <button type="button" className="qrnyama-social-btn">
                <ImageWithBasePath
                  src="/assets/img/icons/google.png"
                  alt="Google"
                  width="20"
                />
                Google
              </button>
              {/* <button type="button" className="qrnyama-social-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="none"
                >
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" />
                </svg>
                Apple
              </button> */}
            {/* </div> */}

            {/* Footer Link */}
            <p className="qrnyama-footer-link">
              Déjà inscrit ?{" "}
              <Link to={route.signin}>Connectez-vous</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;